enum LogLevel {
  DEBUG = 0,
  INFO = 1,
  WARN = 2,
  ERROR = 3
}

class Logger {
  private level: LogLevel = LogLevel.INFO;
  private prefix: string;

  constructor(prefix: string = '[AUTH]') {
    this.prefix = prefix;
    
    // Set log level based on environment variable or default
    const envLogLevel = process.env.REACT_APP_LOG_LEVEL?.toUpperCase();
    
    if (envLogLevel) {
      // Allow override via environment variable
      switch (envLogLevel) {
        case 'DEBUG': this.level = LogLevel.DEBUG; break;
        case 'INFO': this.level = LogLevel.INFO; break;
        case 'WARN': this.level = LogLevel.WARN; break;
        case 'ERROR': this.level = LogLevel.ERROR; break;
        default: this.level = LogLevel.WARN;
      }
    } else {
      // Default behavior - reduced noise
      if (process.env.NODE_ENV === 'development') {
        this.level = LogLevel.WARN; // Reduced from INFO to WARN to minimize debugging noise
      } else {
        this.level = LogLevel.WARN;
      }
    }
  }

  debug(message: string, data?: any): void {
    if (this.level <= LogLevel.DEBUG) {
      console.log(`${this.prefix}[DEBUG] ${message}`, data || '');
    }
  }

  info(message: string, data?: any): void {
    if (this.level <= LogLevel.INFO) {
      console.info(`${this.prefix}[INFO] ${message}`, data || '');
    }
  }

  warn(message: string, data?: any): void {
    if (this.level <= LogLevel.WARN) {
      console.warn(`${this.prefix}[WARN] ${message}`, data || '');
    }
  }

  error(message: string, error?: any): void {
    if (this.level <= LogLevel.ERROR) {
      console.error(`${this.prefix}[ERROR] ${message}`, error || '');
    }
  }

  setLevel(level: LogLevel): void {
    this.level = level;
  }
}

// Create singleton logger instances
export const authLogger = new Logger('[AUTH]');
export const msalLogger = new Logger('[MSAL]');

export { LogLevel };
